import React, { Component } from "react";
import { Input, Tooltip, DatePicker, Row, Col } from "antd";
import moment from "moment";
import "./HRAHistory.css";
import axios from "axios";
import Config from "../../config";

class HRAHistory extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hraHistory: props.HRAHistoryInfo,
      columnHeaders: [
        "Subscriber ID",
        "PCP ID",
        "PCP Name",
        "Member Plan",
        "Created Date",
        "File",
      ],
      sPcpId: "",
      sPcpName: "",
      sPlan: "",
      sCreatedDate: "",
      memberId: this.props.memberId,
      tenantId: sessionStorage.getItem("Tanent"),
    };
  }

  componentDidUpdate = (prevProps) => {
    if (prevProps.HRAHistoryInfo !== this.props.HRAHistoryInfo) {
      this.setState({ hraHistory: this.props.HRAHistoryInfo });
    }
  };

  onPCPIdSearch = (e) => {
    this.setState({ sPcpId: e.target.value });
  };

  onPCPNameSearch = (e) => {
    this.setState({ sPcpName: e.target.value });
  };

  onPlanSearch = (e) => {
    this.setState({ sPlan: e.target.value });
  };

  onCreatedDateChange = async (id, date, dateString) => {
    await this.getHRAHisotryData(
      this.state.tenantId,
      dateString,
      this.state.sPcpId,
      this.state.sPcpName,
      this.state.sPlan
    );
  };

  handleHRASearch = async () => {
    await this.getHRAHisotryData(
      this.state.tenantId,
      this.state.sCreatedDate,
      this.state.sPcpId,
      this.state.sPcpName,
      this.state.sPlan
    );
  };

  getHRAHisotryData = async (
    tenantId,
    createdDate,
    pcpId,
    pcpName,
    planName
  ) => {
    const url = Config.api + "/GetHRADetailsForMember";
    const headers = {
      Authorization: sessionStorage.getItem("access_token"),
    };

    const payload = {
      MemberId: this.state.memberId,
      TenantId: sessionStorage.getItem("Tanent"),
      CreatedDate: createdDate?.length > 0 ? createdDate : null,
      PcPName: pcpName?.trim().length > 0 ? pcpName.trim() : null,
      PcPId: pcpId?.trim().length > 0 ? pcpId.trim() : null,
      MemberPlan: planName?.trim().length > 0 ? planName.trim() : null,
    };

    const response = await axios.post(url, payload, { headers });
    const data = response.data;

    this.setState({
      hraHistory: data.HRADetails,
    });
  };

  tableHeader = () => {
    return (
      <thead className="hra-info-header">
        <th style={{ width: "11%" }}>
          <div>
            <div
              className="sortingArrows"
              style={{ marginBottom: "45px", marginLeft: "15px" }}
            >
              <div> {this.state.columnHeaders[0]}</div>
            </div>
            <div>
              <Input
                className="inputStyle"
                name="memberId"
                type="text"
                value={this.state.claimNumber}
                // onChange={(e) => this.filterOnChange(e)}
                placeholder="Enter"
                size="small"
                // onPressEnter={() => this.getRejectedletterList()}
                hidden
              />
            </div>
          </div>
        </th>
        <th style={{ width: "11%" }}>
          <div>
            <div className="sortingArrows">
              <div style={{ marginLeft: "15px" }}>
                {this.state.columnHeaders[1]}
              </div>
            </div>
            <div>
              <Input
                className="inputStyle"
                name="memberId"
                type="text"
                value={this.state.sCreatedBy}
                onChange={(e) => this.onPCPIdSearch(e)}
                placeholder="Enter"
                size="small"
                onPressEnter={() => this.handleHRASearch()}
              />
            </div>
          </div>
        </th>
        <th style={{ width: "11%" }}>
          <div>
            <div className="sortingArrows">
              <div style={{ marginLeft: "15px" }}>
                {this.state.columnHeaders[2]}
              </div>
            </div>
            <div>
              <Input
                className="inputStyle"
                name="memberId"
                type="text"
                value={this.state.sCreatedBy}
                onChange={(e) => this.onPCPNameSearch(e)}
                placeholder="Enter"
                size="small"
                onPressEnter={() => this.handleHRASearch()}
              />
            </div>
          </div>
        </th>
        <th style={{ width: "11%" }}>
          <div>
            <div className="sortingArrows">
              <div style={{ marginLeft: "15px" }}>
                {this.state.columnHeaders[3]}
              </div>
            </div>
            <div>
              <Input
                className="inputStyle"
                name="memberId"
                type="text"
                value={this.state.sCreatedBy}
                onChange={(e) => this.onPlanSearch(e)}
                placeholder="Enter"
                size="small"
                onPressEnter={() => this.handleHRASearch()}
              />
            </div>
          </div>
        </th>
        <th style={{ width: "11%" }}>
          <div>
            <div className="sortingArrows">
              <div style={{ marginLeft: "15px" }}>
                {this.state.columnHeaders[4]}
              </div>
            </div>
            <div style={{ marginTop: "11px" }}>
              <DatePicker
                size="small"
                className="inputStyle"
                onChange={(date, dateString) =>
                  this.onCreatedDateChange("dosFrom", date, dateString)
                }
                format={"MM/DD/YYYY"}
              />
            </div>
          </div>
        </th>
        <th style={{ width: "11%" }}>
          <div>
            <div
              className="sortingArrows"
              style={{ marginBottom: "45px", marginLeft: "15px" }}
            >
              <div> {this.state.columnHeaders[5]}</div>
            </div>
          </div>
        </th>
      </thead>
    );
  };

  render() {
    return (
      <div className="p-2 pb-3">
        <table>
          {this.tableHeader()}
          <tbody>
            {this.state.hraHistory.map((hraData, idx) => {
              return (
                <>
                  <tr key={idx} className="row-details m-1">
                    <td className="table-data" style={{ width: "13%" }}>
                      <Tooltip
                        title={hraData.MemberId}
                        placement="topLeft"
                        align="left"
                      >
                        {hraData.MemberId ? hraData.MemberId : "---"}
                      </Tooltip>
                    </td>
                    <td className="table-data" style={{ width: "13%" }}>
                      <Tooltip
                        title={hraData.PcpId}
                        placement="topLeft"
                        align="left"
                      >
                        {hraData.PcpId ? hraData.PcpId : "---"}
                      </Tooltip>
                    </td>
                    <td className="table-data" style={{ width: "13%" }}>
                      <Tooltip
                        title={hraData.PcpName}
                        placement="topLeft"
                        align="left"
                      >
                        {hraData.PcpName ? hraData.PcpName : "---"}
                      </Tooltip>
                    </td>
                    <td className="table-data" style={{ width: "13%" }}>
                      <Tooltip
                        title={hraData.MemberPlan}
                        placement="topLeft"
                        align="left"
                      >
                        {hraData.MemberPlan ? hraData.MemberPlan : "---"}
                      </Tooltip>
                    </td>
                    <td className="table-data" style={{ width: "13%" }}>
                      <Tooltip
                        title={hraData.CreatedDateTime}
                        placement="topLeft"
                        align="left"
                      >
                        {hraData.CreatedDateTime
                          ? hraData.CreatedDateTime
                          : "---"}
                      </Tooltip>
                    </td>
                    <td className="table-data" style={{ width: "13%" }}>
                      <Tooltip
                        title={hraData.FilePath}
                        placement="topLeft"
                        align="left"
                      >
                        <a
                          href={hraData.FilePath ? hraData.FilePath : "---"}
                          target="_blank"
                          rel="noreferrer"
                        >
                          Preview
                        </a>
                      </Tooltip>
                    </td>
                  </tr>
                </>
              );
            })}
          </tbody>
        </table>
        {this.state.hraHistory.length === 0 && (
          <div className="mt-5 mb-5 h5 d-flex justify-content-center">
            <span>No Record Found !</span>
          </div>
        )}
      </div>
    );
  }
}

export default HRAHistory;
